import { useEffect, useRef } from 'react'

import { useAuthToken } from '@/hooks/useAuthToken'

import { ActivityRegistry } from '../registry/activity-registry'
import { sendHeartbeat } from '../services/heartbeat-service'

const HEARTBEAT_INTERVAL_MS = 60_000
// Cap prevents unbounded counter growth. The interval keeps running past
// this point (as a no-op) so it can detect resumed activity immediately.
const MAX_IDLE_TICKS = 30

export function useHeartbeatTimer(): void {
  const { getToken, isSignedIn } = useAuthToken()
  const idleCountRef = useRef(0)

  useEffect(() => {
    if (!isSignedIn) return

    const intervalId = setInterval(() => {
      if (ActivityRegistry.isActive) {
        ActivityRegistry.reset()
        idleCountRef.current = 0
        sendHeartbeat(getToken).catch(() => {
          // fire-and-forget: silently ignore failures
        })
      } else if (idleCountRef.current < MAX_IDLE_TICKS) {
        idleCountRef.current += 1
      }
    }, HEARTBEAT_INTERVAL_MS)

    return () => {
      clearInterval(intervalId)
      idleCountRef.current = 0
    }
  }, [isSignedIn, getToken])
}
